/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://gachpqytfneb5mgfoouwjwzdpq.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-abz7drznvnbjzjmfudf3m5p35y",
    "aws_cognito_identity_pool_id": "us-west-2:9cbcfd93-ae10-427d-93b6-2891cf5433fd",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_JBus4am8w",
    "aws_user_pools_web_client_id": "3dr60udjjjt3r2ticvrtcp0a2s",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
